import React from 'react';
import { getSmoothStepPath, useReactFlow } from 'reactflow';
import { Button, Icon } from 'udesk-ui';
import { lineStyle } from './const/lineStyle';

const foreignObjectSize = 25;

export default (props) => {
    const reactFlowInstance = useReactFlow();

    const {
        id,
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourcePosition,
        targetPosition,
        style = {},
        markerEnd,
        source,
        target,
    } = props;
    const [edgePath, labelX, labelY] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    const hiddenDel =
        reactFlowInstance.getNode(source)?.data?.type === 'JUDGE_NODE' &&
        reactFlowInstance.getNode(target)?.data?.type === 'BRANCH';
    return (
        <>
            <path
                id={id}
                style={style}
                className="react-flow__edge-path"
                d={edgePath}
                markerEnd={markerEnd}
                stroke={lineStyle.color}
                strokeWidth={lineStyle.strokeWidth}
            />
            {props.selected && !hiddenDel && (
                <foreignObject
                    width={foreignObjectSize}
                    height={foreignObjectSize}
                    x={labelX - foreignObjectSize / 2}
                    y={labelY - foreignObjectSize / 2}
                    className="edgebutton-foreignobject"
                    requiredExtensions="http://www.w3.org/1999/xhtml"
                >
                    <Button
                        onClick={() => {
                            reactFlowInstance?.deleteElements?.({
                                edges: [props],
                            });
                        }}
                        shape="circle"
                        type="primary"
                        size="small"
                        danger
                        icon={
                            <Icon type="CloseOutlined" antdIcon={true} style={{ marginLeft: 0 }} />
                        }
                    />
                </foreignObject>
            )}
        </>
    );
};
